// Canal del aviso (spec `tree-reports`): por defecto se llega a un árbol escaneando su QR;
// desde el mapa, los enlaces añaden `?desde=mapa`.
export type Channel = 'qr' | 'map'

export const channelFromSearch = (search: string): Channel =>
	new URLSearchParams(search).get('desde') === 'mapa' ? 'map' : 'qr'

export const withChannel = (path: string, channel: Channel): string => (channel === 'map' ? `${path}?desde=mapa` : path)
